import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import trend2 from "../Images/trend2.png";
import trend4 from "../Images/trend4.png";
const Trendingnow = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center">
              Discover What’s Hot On Google With Trending Now
            </h1>

            <p>
              In SEO, timing makes a big difference. You have the best content,
              but publishing it at the wrong time will not give you the desired
              result. That’s where SeoBix's “Trending Now” feature can help you
              by providing the keyword’s insights. It helps you to find what is
              trending in the market, so you get more traffic.
            </p>

            <p>
              Now let's dive into the “Trending Now” feature. What this feature
              is actually about, how it works, and why it is an important
              feature for your SEO featurebox.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={trend2}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h2>What Is Trending Now On Google</h2>

            <p>
              The “Trending Now” feature helps you find the keywords, topics
              that are currently trending across the world. Instead of working
              on outdated topics or broad keyword lists, this feature helps you
              focus on market trends. You can find the right keywords and
              real-time insights
            </p>

            <h3>How “Trending Now” Helps You Rank Faster</h3>
            <p>
              Awareness of the trends makes you ahead of the game, allowing you
              to create community-created content and seize a chance to rank for
              keywords before they become overcrowded.
            </p>
            <h3>Find Fresh Content Ideas</h3>

            <p>
              Finding new ideas for blog posts from social media updates is not
              much effective, you can use "Trending Now" to identify content
              ideas that are already popular. This makes you stay up to date and
              release content your audience actually cares about.
            </p>

            <h3>Target High-Potential Keywords</h3>

            <p>
              Once you find trending topics, you want keywords so you can use
              them to find the right audience for your topic. The Trending Now
              feature helps you by providing user search queries. This helps you
              make smart decisions about which keywords to focus on for your
              next blog or landing page.
            </p>

            <h3>Optimize for Local and Global Audiences</h3>

            <p>
              With filtering options, you can see what’s trending in your
              specific region or industry. This is perfect for local SEO or
              niche markets. Whether you’re a travel blogger, tech startup, or
              local bakery, you’ll always know what topics are gaining traction
              near you.
            </p>

            <h3>Real-Time Insights for Smarter SEO</h3>

            <p>
              SeoBix constantly monitors the operations of search engines to
              analyze trends and digital signals, which may indicate valid
              spikes in keyword interest. This information is then
              systematically arranged for your benefit and displayed on an
              easy-to-read dashboard with real-time updates.
            </p>

            <p>
              With such information, you will be able to see which topics are
              heating up, to what degree they are attracting attention, and if
              such trends are applicable to your audience or territory. It is
              like having your own SEO trend radar at your fingertips
            </p>

            <h2>Why Should You Use Trending Now?</h2>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={trend4}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h3>Stay Ahead of the Competition</h3>

            <p>
              SEO is a race, and if you’re not ahead of the trends, you’re
              behind. “Trending Now” helps you get a jump on hot topics before
              they become oversaturated. The earlier you target trending
              keywords, the better your chances of ranking high on Google.
            </p>

            <h3>Improve Your Timing</h3>

            <p>
              When you use “Trending Now”, you’re not just guessing. You’re
              working with real-time data that shows you what’s gaining traction
              right now. This allows you to create and publish content at the
              perfect moment to catch the wave of interest.
            </p>

            <h3>Boost Your Traffic</h3>

            <p>
              Content related to trending topics can attract the maximum number
              of visitors. The more desirable a topic is for people to click on,
              the more attractive it becomes to host on the site trending list,
              which essentially puts forth the voices of current audience needs.
            </p>

            <h2>Conclusion</h2>

            <p>
              In the fast-paced world of trends, it is very important to be at
              the lead. With SeoBix's "Trending Now" feature, you will never
              have to guess what your audience wants- you will know for sure. It
              helps you to catch rising trends very early, write content related
              to them, and achieve faster ranking.
            </p>

            <p>
              Whether you are an absolute beginner to SEO, someone who engages
              in blogging, or a working digital agency, "Trending Now" gives you
              the wisdom to be able to lead rather than follow..
            </p>

            <p>
              <b>
                {" "}
                Try SeoBix today and start ranking for what matters right now.
              </b>
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Trendingnow;
